import React, { Component } from 'react';
import './BankFailure.scss';
import If from '../../../components/Shared/If/If';
import Case from '../../../components/Shared/Switch/Case';
import Switch from '../../../components/Shared/Switch/Switch';
import EverifyAccountLockout from '../../../components/Bank/BankFailure/SharedFailures/Lockout/EverifyAccountLockout';
import PlaidAccountLockout from '../../../components/Bank/BankFailure/SharedFailures/Lockout/PlaidAccountLockout';
import Generic from '../../../components/Bank/BankFailure/SharedFailures/Generic/Generic';
import Denial from '../../../components/Bank/BankFailure/SharedFailures/Denial/Denial';
import TechnicalBankFailure from './TechnicalBankFailure';
import { LINK, MANUAL } from '../../../settings/settings';

export class BankFailure extends Component {
  constructor(props) {
    super(props);
    this.state = {
      started: true,
    };
  }

  render() {
    const {
      eVerification: { attempts: everifyAttempts },
      linkedBanks: { attempts: plaidAttempts },
      path,
      setBankProgress,
      // buttonDescription,
      // buttonDestination,
      handleClose,
      dispatchPageLoad,
      isSalesforceRep,
    } = this.props;
    /**
     *  Cache should always be the gold source (left side of OR statement) but just in case there is an error or missed call we then fallback to session attempts
     **/
    return (
      <div>
        <Switch test={path}>
          <Case value={MANUAL}>
            <If test={everifyAttempts === 0 && plaidAttempts === 0}>
              <TechnicalBankFailure
                dispatchPageLoad={dispatchPageLoad}
                isSalesForceRep={isSalesforceRep}
                setBankProgress={setBankProgress}
                handleClose={handleClose}
                path={path}
              />
            </If>
            <If test={everifyAttempts === 1}>
              <Generic
                setBankProgress={setBankProgress}
                plaidAttempts={plaidAttempts}
                everifyAttempts={everifyAttempts}
                isSalesforceRep={isSalesforceRep}
                path={path}
              />
            </If>
            {/** Design pending */}
            <If test={everifyAttempts === 2}>
              <Generic
                setBankProgress={setBankProgress}
                plaidAttempts={plaidAttempts}
                everifyAttempts={everifyAttempts}
                isSalesforceRep={isSalesforceRep}
                path={path}
              />
            </If>
            <If test={everifyAttempts > 2 && plaidAttempts <= 2}>
              <EverifyAccountLockout
                setBankProgress={setBankProgress}
                isSalesforceRep={isSalesforceRep}
              />
            </If>
            <If test={everifyAttempts > 2 && plaidAttempts > 2}>
              <Denial />
            </If>
          </Case>
          <Case value={LINK}>
            <If test={everifyAttempts === 0 && plaidAttempts === 0}>
              <TechnicalBankFailure
                dispatchPageLoad={dispatchPageLoad}
                isSalesForceRep={isSalesforceRep}
                setBankProgress={setBankProgress}
                handleClose={handleClose}
                path={path}
              />
            </If>
            <If test={plaidAttempts === 1}>
              <Generic
                setBankProgress={setBankProgress}
                plaidAttempts={plaidAttempts}
                everifyAttempts={everifyAttempts}
                isSalesforceRep={isSalesforceRep}
                path={path}
              />
            </If>
            {/** Design pending */}
            <If test={plaidAttempts === 2}>
              <Generic
                setBankProgress={setBankProgress}
                plaidAttempts={plaidAttempts}
                everifyAttempts={everifyAttempts}
                isSalesforceRep={isSalesforceRep}
                path={path}
              />
            </If>
            <If test={plaidAttempts > 2 && everifyAttempts <= 2}>
              <PlaidAccountLockout setBankProgress={setBankProgress} />
            </If>
            <If test={everifyAttempts > 2 && plaidAttempts > 2}>
              <Denial />
            </If>
          </Case>
        </Switch>
      </div>
    );
  }
}

export default BankFailure;
